/**
 * Events detail
 */
import {debounce, getElementFromSelector} from '@ifabnpm/bootstrap/utils.js';
import {scrollTop} from '@ifabnpm/bootstrap/utils/scroll.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

import Reveal from '@ifabnpm/bootstrap/component/reveal.js';

// -------
// Private
// -------

const setupEventDateGroup = async (toggle, container) => {
	const elements = SelectorEngine.find('.-hidden[data-delimiter], .-hidden[data-event-date-item]', container);

	if (elements.length > 0) {
		const elementsReversed = [...elements].reverse();

		EventHandler.on(toggle, `click`, (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.target.getAttribute('aria-pressed') === 'true') {
				for (const element of elementsReversed) {
					Reveal.hide(element).then(element => {
						Manipulator.setAria(toggle, 'pressed', 'false');
						window.setTimeout(() => {
							scrollTop(toggle);
						}, 250);
					});
				}
			} else {
				for (const element of elements) {
					Reveal.show(element).then(element => {
						Manipulator.setAria(toggle, 'pressed', 'true');
					});
				}
			}
		});
	} else {
		toggle.remove();
	}
};

let lineClampingTargets = [];

const setupLineClamping = async () => {
	const toggles = SelectorEngine.find('button[data-custom-toggle="line-clamping"]');

	if (toggles.length > 0) {
		for (const toggle of toggles) {
			const target = getElementFromSelector(toggle);

			if (target) {
				lineClampingTargets.push(target);

				EventHandler.on(target, `checkOverflowing`, (event) => {
					if(event.target.scrollHeight > event.target.clientHeight) {
						event.target.dataset.lineClampingEnabled = 'true';
					} else {
						delete event.target.dataset.lineClampingEnabled;
					}
				});

				EventHandler.on(toggle, `click`, (event) => {
					event.preventDefault();
					event.stopPropagation();

					if (event.target.getAttribute('aria-pressed') === 'true') {
						delete target.dataset.expanded;
						Manipulator.setAria(toggle, 'pressed', 'false');

						window.setTimeout(() => {
							scrollTop(toggle);
						}, 250);
					} else {
						target.dataset.expanded = 'true';
						// Manipulator.setAria(toggle, 'pressed', 'true');
						toggle.remove();
					}
				});

				EventHandler.trigger(target, 'checkOverflowing');
			} else {
				toggle.remove();
			}
		}

		if (lineClampingTargets.length > 0) {
			window.addEventListener('resize', debounce(() => {
				for (const element of lineClampingTargets) {
					EventHandler.trigger(element, 'checkOverflowing');
				}
			}, 200));
		}
	}
};

// --------
// Let's go
// --------

window.addEventListener('load', async function() {
	const togglesDateItemGroup = SelectorEngine.find('button[data-custom-toggle="event-date-item-group"]');

	for (const toggle of togglesDateItemGroup) {
		const target = getElementFromSelector(toggle);

		if (target) {
			await setupEventDateGroup(toggle, target);
		} else {
			toggle.remove();
		}
	}

	await setupLineClamping();
});
